import type { AddFileModalOption } from './components/AddFileModal';

type ModalOptionsConfig = {
  t: (key: string) => string;
  cameraAvailable: boolean;
  onClose: () => void;
  pickFromLibrary: () => Promise<void>;
  takePhoto: () => Promise<void>;
  chooseFile: () => Promise<void>;
};

export const buildAddFileModalOptions = ({
  t,
  cameraAvailable,
  onClose,
  pickFromLibrary,
  takePhoto,
  chooseFile,
}: ModalOptionsConfig): AddFileModalOption[] => {
  const wrapAction =
    (action: () => Promise<void>): (() => void) =>
    () => {
      onClose();
      void action();
    };

  const options: AddFileModalOption[] = [
    {
      key: 'photoLibrary',
      label: t('speciesSearch.modals.photoLibrary'),
      icon: 'image-outline',
      onPress: wrapAction(pickFromLibrary),
    },
  ];

  if (cameraAvailable) {
    options.push({
      key: 'takePhoto',
      label: t('speciesSearch.modals.takePhoto'),
      icon: 'camera-outline',
      onPress: wrapAction(takePhoto),
    });
  }

  options.push({
    key: 'chooseFile',
    label: t('speciesSearch.modals.chooseFile'),
    icon: 'folder-open-outline',
    onPress: wrapAction(chooseFile),
  });

  return options;
};

export const VERTEBRATE_TAXON = '8V4V3';
